import type { OrderDetailsOrderLine } from '@/types/orderDetailsOrder';

import type { WithdrawalEligibility, WithdrawalEligibilityLine } from './types';
import { isWithdrawalExcludedOrderLine } from './withdrawalExcludedProductTypes';

export function isEligibleLine(line: WithdrawalEligibilityLine): boolean {
  return line.status === 'ELIGIBLE' || line.eligibleQuantity > 0;
}

export function hasAnyEligibleLines(
  eligibility: WithdrawalEligibility,
  orderLinesById?: ReadonlyMap<string, OrderDetailsOrderLine>,
): boolean {
  return eligibility.lines.some((line) => {
    if (orderLinesById) {
      const orderLine = orderLinesById.get(line.orderLineId);
      if (orderLine && isWithdrawalExcludedOrderLine(orderLine)) {
        return false;
      }
    }
    return isEligibleLine(line);
  });
}

export function shouldShowWithdrawalCta(
  eligibility: WithdrawalEligibility | null | undefined,
  orderLinesById?: ReadonlyMap<string, OrderDetailsOrderLine>,
): boolean {
  if (!eligibility) return false;
  if (eligibility.code !== 'OK') return false;
  return hasAnyEligibleLines(eligibility, orderLinesById);
}
